import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";

const CourierActivityFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false
}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.courierActivity", {ns: "common"})}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="courierActivity"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="courierActivity_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                <SelectField.Option data-testid="courierActivity_option" value={"enabled"}>
                    {t("courierActivityStatuses.activeCouriers", {
                        ns: "courierPage"
                    })}
                </SelectField.Option>
                <SelectField.Option data-testid="courierActivity_option" value={"disabled"}>
                    {t("courierActivityStatuses.inactiveCouriers", {
                        ns: "courierPage"
                    })}
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default CourierActivityFilter;
